export {default as makeCommunicationActionType} from './makeCommunicationActionTypes';
export {default as makeResetCommunicationActionType} from './makeResetCommunicationActionTypes';
export {default as makeCommunicationReducer} from './makeCommunicationReducer';
export {default as makeCommunicationReducerFromEnum} from './makeCommunicationReducerFromEnum';
export * from './types';
export {default as initialCommunication, getInitialCommunication} from './initial';
export {default as makeResetCommunicationReducer} from './makeResetCommunicationReducer';
export {default as composeCommunication} from './composeCommunication';
